module.exports = {
    START_MATCH: 'START_MATCH',
    START_BET: 'START_BET',
    ASK_QUESTION: 'ASK_QUESTION',
    SEND_ANSWER_RESULTS: 'SEND_ANSWER_RESULTS',
    GET_QUESTIONS: 'GET_QUESTIONS',
    SAVE_QUESTION: 'SAVE_QUESTION',
    SAVE_ANSWER: 'SAVE_ANSWER',
    DELETE_ANSWER: 'DELETE_ANSWER',
    DELETE_QUESTION: 'DELETE_QUESTION',
    SAVE_MATCH: 'SAVE_MATCH',
    GET_MATCHES: 'GET_MATCHES',
    DELETE_MATCH: 'DELETE_MATCH',
    STOP_MATCH: 'STOP_MATCH',
    SEND_CHART: 'SEND_CHART',
    GET_QUESTION_GAME: 'GET_QUESTION_GAME',
    START_STREAMING: 'START_STREAMING',
    STOP_STREAMING: 'STOP_STREAMING',
    GET_USERS:'GET_USERS',
    GAVE_EXP_USER : 'GAVE_EXP_USER',
    CALL_USER: 'CALL_USER',
    CLOSE_CALL: 'CLOSE_CALL',
    GET_BETS: 'GET_BETS',
    GET_USER_POINTS: 'GET_USER_POINTS',
    CHANGE_USER_POINTS : 'CHANGE_USER_POINTS',
    ENABLE_CHAT: 'ENABLE_CHAT',
    DISABLE_CHAT: 'DISABLE_CHAT',
    START_AUTOSTREAM: 'START_AUTOSTREAM',
    STOP_AUTOSTREAM: 'STOP_AUTOSTREAM',
    SET_NUMBER_OF_CHATTERS: 'SET_NUMBER_OF_CHATTERS',
    SET_USERS_LIMIT_NUMBER: 'SET_USERS_LIMIT_NUMBER',
    RESTORE_GAME: 'RESTORE_GAME',
    DELETE_SNAPSHOT: 'DELETE_SNAPSHOT',
    DELETE_TEMPORARY_USER: 'DELETE_TEMPORARY_USER'
}


// WEBPACK FOOTER //
// ./src/events/DashboardToServer.js